import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const QuoteButton = ({ textName,url }) => {
    const [show, setShow] = useState(false);
    const [citationText, setCitationText] = useState('');
    const [copied, setCopied] = useState(false); // Track whether the citation has been copied

    const handleClose = () => setShow(false);
    const handleShow = () => {
        // Update the citation text with the current date when the modal is opened
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
        });

        const newCitationText = `Percentager.net. Available at: ${url}/ . Accessed: ${formattedDate}.`;
        setCitationText(newCitationText);
        setCopied(false); // Reset the copied status when opening the modal
        setShow(true);
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(citationText);
        setCopied(true); // Update the button state to show copied
    };

    return (
        <>
            <button
                onClick={handleShow}
                style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}
                className=' btn btn-secondary btn-lg'
            >
               {textName ? textName : 'Cite'}
            </button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Citation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        readOnly
                        value={citationText}
                        style={{ fontFamily: 'monospace' }}
                    />
                    <Button
                        variant={copied ? "success" : "primary"} // Change button color based on copied status
                        style={{ marginTop: '10px', color: 'white' }}
                        onClick={handleCopy}
                    >
                        {copied ? "Copied!" : "Copy Citation"} {/* Change button text based on copied status */}
                    </Button>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default QuoteButton;
